import styled from "styled-components";

const montserrat = (props) => props.theme.fonts.montserrat;

export const StatusStyle = styled.div`
  padding: 8px 16px;
  color: white;
  background-color: ${(props) => props.color};
  font-family: ${montserrat};
  border-radius: 999px;
`;
